export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9124.9f4263c1.jpg";